<template>
	
<div class="riskf" :class="{'is-active': active}">

	<div class="riskf-title"><span>{{ section.risk.title }}<small>{{ section.risk.subtitle }}</small></span><com-info :info="info" class="riskf-title-info" v-if="info" /></div>

	<div class="riskf-score">

		<div class="riskf-score-hundred">{{ score }} <small>in</small> 100</div>
		<div class="riskf-score-percent"><span>{{ score }}%</span> in the next 10 years</div>

	</div>

	<div class="riskf-buttons">

		<div class="riskf-buttons-text">If you want to know what your fracture risk score means click here.</div>
		<div class="riskf-buttons-button is-cates" v-on:click="$emit('cates')"></div>
		<div class="riskf-buttons-button is-toggle" v-if="!$isPatient" v-on:click="$emit('graph')"></div>

	</div>

	<div class="riskf-note">{{ section.risk.note }}</div>

</div>

</template>

<script>

import comInfo from '@/components/tool/common/section/form/Info'

export default {

	props: ['section', 'active', 'completed', 'info'],

	components: {
		'com-info': comInfo
	},

	computed: {

		score: function() {

			return Math.round(this.frax('major'))

		}

	}
	
}

</script>

<style scoped>

.riskf {
	width: 50%;
	height: 297px;
	background-color: #FECC66;
	border-bottom-right-radius: 48px;
	padding: 30px;
	filter: grayscale(100%);
	opacity: 0.25;
	transition: all 300ms linear;
}

.riskf.is-active {
	opacity: 1;
	filter: grayscale(0%);
}

.riskf-title {
	color: #343434;
	font-size: 18px;
	letter-spacing: 1px;
	text-align: right;
	font-weight: 600;
	text-transform: uppercase;
	margin-bottom: 30px;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 10px;
}

.riskf-title .riskf-title-info {
	position: relative;
	right: auto;
	top: auto;
}

.riskf-title small {
	display: block;
	font-size: 12px;
	margin-top: 4px;
}

.riskf-title:after {
	content: ' ';
	display: block;
	position: absolute;
	height: 2px;
	right: 0px;
	width: 75px;
	bottom: -10px;
	background-color: #fff;
}

.riskf-score {
	text-align: right;
	margin-bottom: 25px;
}

.riskf-score-hundred {
	color: #343434;
	font-size: 65px;
	font-weight: 600;
	display: flex;
	justify-content: flex-end;
	align-items: baseline;
	letter-spacing: 6px;
}

.riskf-score-hundred small {
	font-size: 16px;	
	text-transform: uppercase;
	padding: 0px 10px;
	letter-spacing: 1px;
}

.riskf-score-percent {
	color: #343434;
	font-size: 14px;
	margin-top: 10px;
	font-weight: 600;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	letter-spacing: 1px;
}

.riskf-score-percent span {
	font-size: 20px;
	letter-spacing: 2px;
	margin-right: 4px;
}

.riskf-buttons {
	display: flex;
	justify-content: flex-end;
	align-items: center;
}

.riskf-buttons-text {
	text-transform: uppercase;
	color: #343434;
	font-size: 10px;
	letter-spacing: 1px;
	font-weight: 600;
	margin-right: 10px;
	text-align: right;
	padding-left: 32px;
}

.riskf-buttons-button {
	cursor: pointer;
	flex-shrink: 0;
	width: 44px;
	margin-left: 10px;
	height: 44px;
	border-radius: 22px;
	background-color: #656D78;
	background-position: 50% 50%;
	background-repeat: no-repeat;
}

.riskf-buttons-button.is-cates {
	background-image: url(~@/assets/aid/risk/risk/cates.svg);
}

.riskf-buttons-button.is-toggle {
	background-image: url(~@/assets/aid/risk/risk/toggle.svg);
}

.riskf-note {
	color: #343434;
	font-weight: 600;
	font-size: 12px;
	letter-spacing: 1;
	position: absolute;
	bottom: 10px;
	left: 100px;
}

</style>